import * as yup from "yup";
import { ReactSelectOption } from "../../models/generic";
import { FormValidationModel } from "../../models/validation";
import { AddressData, AddressSchema, DefaultAddress, ReactSelectOptionSchema } from "../generic";

export interface EventData {
    abstractsEnabled: boolean;
    abstractInvitationNotes: string | null;
    abstractSubmissionsOpen: Date | null;
    active: boolean;
    address: AddressData;
    description?: string;
    endDate: Date;
    id: number;
    locationName?: string;
    startDate: Date;
    timezone: ReactSelectOption | null;
    title: string;
}

export class Event implements FormValidationModel<EventData> {
    public data: EventData;
    public rules: yup.Schema<EventData>;

    public constructor() {
        this.data = {
            abstractsEnabled: false,
            abstractInvitationNotes: "",
            abstractSubmissionsOpen: null,
            active: true,
            address: { ...DefaultAddress },
            description: "",
            endDate: new Date(),
            id: 0,
            locationName: "",
            startDate: new Date(),
            timezone: null,
            title: "",
        };
        this.rules = yup.object<EventData>().shape({
            abstractsEnabled: yup.bool().label("Abstract submissions"),
            abstractInvitationNotes: yup.string().nullable(true).label("Invitation notes"),
            abstractSubmissionsOpen: yup.date().nullable(true).label("Submissions open on").when(["abstractsEnabled"], (abstractsEnabled: boolean) => {
                const schema = yup.date().nullable(true).label("Submissions open on");
                return abstractsEnabled
                    ? schema.required()
                    : schema;
            }),
            active: yup.bool().label("Active"),
            address: AddressSchema.label("Address"),
            description: yup.string().nullable(true).label("Description"),
            endDate: yup.date().nullable(true).required().label("Ends on"),
            id: yup.number().required().min(0, "Invalid $label").label("ID"),
            locationName: yup.string().nullable(true).max(150).label("Location name"),
            startDate: yup.date().nullable(true).required().label("Starts on"),
            timezone: ReactSelectOptionSchema.nullable(true).required().label("Time zone"),
            title: yup.string().required().label("Title").max(255),
        });
    }
}



// WEBPACK FOOTER //
// ./src/forms/adminEvent/Event.ts